import { Badge, BadgeType } from '../../../../../../../components/badge/badge';
import { FONT_COLOR } from '../../../../../../../components/fonts/font-props';
import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import Collapsible, {
    COLLAPSIBLE_COLOR_VARIANT,
    COLLAPSIBLE_TRIGGER_ICON_VARIANT,
    ICON_POSITION,
} from "../../../../../../../components/collapsible/collapsible";

import { IProductItemDiscountDto, IProductItemDto } from '../../../refund-calculator-types';

import CalculatorLineItem from '../calculator-line-item/calculator-line-item';

import './calculator-product-item.scss';

const CalculatorProductItem: React.FC<IProductItemDto> = (data) => {

    const renderDiscounts = (discounts: IProductItemDiscountDto[]) => {
        if (discounts?.length === 0) {
            return null;
        }

        return (
            <span className="refund-calculator__product-item-badge">
                {discounts.map((discount: IProductItemDiscountDto, index: number) => {
                    return (
                        <Badge key={index} type={BadgeType.DEFAULT} text={discount.code} />
                    );
                })}
            </span>
        );
    };

    return (
        <div className="refund-calculator__product-item">
            <Collapsible
                colorVariant={COLLAPSIBLE_COLOR_VARIANT.ACCENT}
                iconVariant={COLLAPSIBLE_TRIGGER_ICON_VARIANT.ARROW2}
                iconPosition={ICON_POSITION.LEFT}
                title={(
                    <CalculatorLineItem
                        boldText={true}
                        description={
                            <div className="refund-calculator__product-item-title">
                                <div className="product-item-basic-info">
                                    <span>{data.title}</span>
                                    {data.variant_name ? (
                                        <FontBody2 color={FONT_COLOR.NEUTRAL3}>{` ${data.variant_name}`}</FontBody2>
                                    ) : null}
                                    {renderDiscounts(data.discounts || [])}
                                </div>
                                {data.resolution ? (
                                    <div className="refund-calculator__product-item-badge">
                                        <Badge type={BadgeType.INFO} text={data.resolution.label} />
                                    </div>
                                ) : null}
                            </div>
                        }
                        price={data?.price?.total_price?.amount || 0}
                        tax={data?.price?.total_price?.tax || 0}
                        taxRate={data?.price?.total_price?.tax_rate || 0}
                    />
                )}
            >
                <div className="refund-calculator__product-item_content">
                    {data?.price?.price_adjustment && data?.price?.original_price ? (
                        <>
                            <CalculatorLineItem
                                description="Catalog price"
                                price={data.price.price_adjustment.amount + data.price.original_price.amount}
                                tax={data.price.price_adjustment.tax + data.price.original_price.tax}
                            />
                            <div className="refund-calculator__product-item_content">
                                {data.price.original_price.amount > 0 ? (
                                    <CalculatorLineItem
                                        description="Original price"
                                        price={data.price.original_price.amount}
                                        tax={data.price.original_price.tax}
                                        taxRate={data.price.original_price.tax_rate || 0}
                                    />
                                ) : null}
                                {data.price.price_adjustment.amount > 0 ? (
                                    <CalculatorLineItem
                                        description="Catalog price adjustment"
                                        price={data.price.price_adjustment.amount}
                                        tax={data.price.price_adjustment.tax}
                                        taxRate={data.price.price_adjustment.tax_rate || 0}
                                    />
                                ) : null}
                            </div>
                        </>
                    ) : null}
                    {(data.compare_at_price_discount && data.compare_at_price_discount.amount > 0) ? (
                        <CalculatorLineItem
                            description={
                                "Compare at price discount" + (data.compare_at_price_discount.percentage ? `: ${data.compare_at_price_discount.percentage}%` : '')
                            }
                            price={data.compare_at_price_discount.amount}
                            tax={data.compare_at_price_discount.tax}
                            taxRate={data.compare_at_price_discount.tax_rate || 0}
                        />
                    ) : null}
                    {(data.bxgy_discount_cancellation_fee && data.bxgy_discount_cancellation_fee.amount > 0) ? (
                        <CalculatorLineItem
                            description={
                                "BxGy discount cancellation fee" + (data.bxgy_discount_cancellation_fee.percentage ? `: ${data.bxgy_discount_cancellation_fee.percentage}%` : '')
                            }
                            price={data.bxgy_discount_cancellation_fee.amount}
                            tax={data.bxgy_discount_cancellation_fee.tax}
                            taxRate={data.bxgy_discount_cancellation_fee.tax_rate || 0}
                        />
                    ) : null}
                    {(data.exchange_range_adjustment && data.exchange_range_adjustment.amount > 0) ? (
                        <CalculatorLineItem
                            description={
                                "Exchange range adjustment" + (data.exchange_range_adjustment.percentage ? `: ${data.exchange_range_adjustment.percentage}%` : '')
                            }
                            price={data.exchange_range_adjustment.amount}
                            tax={data.exchange_range_adjustment.tax}
                            taxRate={data.exchange_range_adjustment.tax_rate || 0}
                        />
                    ) : null}
                    {(data.old_switch_to_exchange && data.old_switch_to_exchange.amount > 0) ? (
                        <CalculatorLineItem
                            description={
                                "Old switch to exchange" + (data.old_switch_to_exchange.percentage ? `: ${data.old_switch_to_exchange.percentage}%` : '')
                            }
                            price={data.old_switch_to_exchange.amount}
                            tax={data.old_switch_to_exchange.tax}
                            taxRate={data.old_switch_to_exchange.tax_rate || 0}
                        />
                    ) : null}
                    {(data.refund_adjustment && data.refund_adjustment.amount > 0) ? (
                        <CalculatorLineItem
                            description={
                                "Refund adjustment" + (data.refund_adjustment.percentage ? `: ${data.refund_adjustment.percentage}%` : '')
                            }
                            price={data.refund_adjustment.amount}
                            tax={data.refund_adjustment.tax}
                            taxRate={data.refund_adjustment.tax_rate || 0}
                        />
                    ) : null}
                    {(data.bxgy_discount && data.bxgy_discount.amount > 0) ? (
                        <CalculatorLineItem
                            description="BxGy discount"
                            price={data.bxgy_discount.amount}
                            tax={data.bxgy_discount.tax}
                            taxRate={data.bxgy_discount.tax_rate || 0}
                        />
                    ) : null}
                    {data.duties ? (
                        <CalculatorLineItem
                            description={`Duties: ${data.is_duties_included ? 'included' : 'not included'}`}
                            price={data.duties.amount}
                            tax={data.duties.tax}
                        />
                    ) : null}
                </div>
            </Collapsible>
        </div>
    );
};

export default CalculatorProductItem;
